import { combineReducers } from "redux";
import user from "./user";
import friend from "./friend";
import loading from "./loading";
import hiclasstv from "./hiclasstv";
import chat from "./chat";
import live from "./live";
import quiz from "./quiz";
import classTalk from "./classTalk";
import classTalkLive from "./classTalkLive";
import promotion from "./promotion";
import pass from "./pass";
import admin from "./admin";
import studio from "./studio";
import service from "./service";
import whisper from "./whisper";
import groupChat from "./groupChat";
// import robot from "./robot";

const rootReducer = combineReducers({
    user,
    friend,
    chat,
    classTalk,
    loading,
    hiclasstv,
    live,
    classTalkLive,
    quiz,
    promotion,
    pass,
    admin,
    studio,
    service,
    whisper,
    groupChat
});

export default rootReducer;